export enum PhotoInformationAlignment {
    Left = 'Left',
    Right = 'Right'
}

export enum PhotoMetadataType {
    Timestamp = 'Timestamp',
    Reference = 'Reference',
    Address = 'Address'
}

export interface PhotoMetadataOrderItem {
    type: PhotoMetadataOption;
    order: number;
}

export interface PhotoSettings {
    displayTimestampOnImage: boolean,
    displayReferenceOnImage: boolean,
    /** @deprecated use photoAddressOptions */
    photoAddressOption: PhotoAddressOption,
    photoAddressOptions: PhotoAddressOption[],
    photoReferenceOptions: PhotoReferenceOption[],
    photoInformationAlignment: PhotoInformationAlignment,
    displayTransparentBackground: boolean,
    displayDataStampOnDifferentLine: boolean,
    metadataDisplayOrder?: PhotoMetadataOption[];
}

export enum PhotoReferenceOption {
    Timestamp = 'Timestamp',
    JobNumber = 'Job Number',
    StageNumber = 'Stage Number',
    StageName = 'Stage Name',
    CustomerWo = 'Customer WO',
}

export enum PhotoAddressOption {
    GPSCoordinates = 'GPS Coordinates',
    GPSLocation = 'GPS Location',
    JobAddress = 'Job Address',
    None = 'None'
}

export type PhotoMetadataOption =
    | PhotoReferenceOption
    | PhotoAddressOption
    | 'Timestamp';

/** Keep the user's order when selections change; new stamp values join at the end. */
export function getPhotoMetadataDisplayOrder(settings: PhotoSettings): PhotoMetadataOption[] {

  const enabled = new Set<PhotoMetadataOption>([
    ...(settings.displayTimestampOnImage ? [PhotoReferenceOption.Timestamp] : []),
    ...(settings.photoReferenceOptions ?? []),
    ...(settings.photoAddressOptions ?? []),
  ]);
  const existing = (settings.metadataDisplayOrder ?? [])
    .filter(option => enabled.has(option));

  return [...new Set([...existing, ...enabled])];
}
